import { Spin } from 'antd';
import React from 'react';

const Loader = () => {

    return (
        <div
            id='loader'
            style={{
                position: "fixed",
                width: "100%",
                height: "100vh",
                overflow: "hidden",
                top: 0,
                left: 0,
                background: "rgba(230, 244, 255, .5)",
                zIndex: 99999,
                display: "none",
                alignItems: "center",
                justifyContent: "center"
            }}>
            <Spin size="large" />
        </div>
    )
};

export default Loader;
